import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="max-w-2xl mx-auto text-center py-16">
      <div className="text-9xl font-bold text-kf-orange-600/20 mb-4">404</div>
      <h1 className="text-3xl font-bold text-kf-gray-900 mb-4">Siden ble ikke funnet</h1>
      <p className="text-kf-gray-600 mb-8">
        Beklager, vi kunne ikke finne siden du leter etter.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/" className="btn-primary inline-flex items-center justify-center gap-2">
          <Home className="w-5 h-5" />
          Hjem
        </Link>
        <button onClick={() => window.history.back()} className="btn-secondary inline-flex items-center justify-center gap-2">
          <ArrowLeft className="w-5 h-5" />
          Tilbake
        </button>
      </div>
    </div>
  );
}
